import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppState } from "../appstates";
import "../component/css/Second_header.css";
import LogoImg from "../Image/Logo.png";
import HomeImg from "../Image/Home.png";
import CmaImg from "../Image/Cma.png";
import ServicsImg from "../Image/servics.png";
import HelpImg from "../Image/help.png";
import ProfileImg from "../Image/profile.png";
import BellImg from "../Image/bell.png";

const Secondheader = () => {
  const { state, dispatch } = useAppState();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const isAuthed = !!sessionStorage.getItem("token");

  const currentPath = (location.pathname || "").toLowerCase();
  const logoNavDisabled =
    currentPath.startsWith("/equipment") ||
    currentPath.startsWith("/inventorylist");

  const handleLogout = () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);

    // Preserve the app base path (e.g. /app/) so the redirect lands on React.
    const loginUrl = window.location.origin + window.location.pathname + "#/";

    // Tell the rest of the app we just logged out. Both AuthHandler and the
    // Login page check this to avoid auto-re-authenticating.
    sessionStorage.setItem("justLoggedOut", "1");
    localStorage.setItem("justLoggedOut", String(Date.now()));

    // Hard fallback in case the SDK hangs or never navigates.
    const fallbackTimer = setTimeout(() => {
      window.location.replace(loginUrl);
    }, 5000);

    try {
      if (
        window.catalyst &&
        window.catalyst.auth &&
        typeof window.catalyst.auth.signOut === "function"
      ) {
        // Do NOT clear sessionStorage before this - the SDK may need it.
        // Do NOT await - signOut triggers its own navigation and never resolves.
        window.catalyst.auth.signOut(loginUrl);
      } else {
        clearTimeout(fallbackTimer);
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem("justLoggedOut", "1");
        window.location.replace(loginUrl);
      }
    } catch (err) {
      console.error("Logout failed", err);
      clearTimeout(fallbackTimer);
      window.location.replace(loginUrl);
    }
  };

  useEffect(() => {
    console.log(state.ActiveMenu);
  }, [state.ActiveMenu]);

  const updateActivemenu = (value, link) => {
    dispatch({ type: "SET_ACTIVE_NAV", payload: value });
    navigate(link);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.querySelector(".Hamburger").classList.toggle("open");
  };

  return (
    <div className="Secondheader">
      <div className="In_logo">
        <img
          src={LogoImg}
          alt="logo2.0"
          className="Logo_img"
          style={{ cursor: logoNavDisabled ? "default" : "pointer" }}
          onClick={
            logoNavDisabled
              ? undefined
              : () =>
                  updateActivemenu(
                    "Home",
                    isAuthed ? "/user-Machines" : "/equipment"
                  )
          }
        />
      </div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>

      <button className="Hamburger" onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div>
        <div className={`Menu_text ${isMobileMenuOpen ? "open" : ""}`}>
          {isAuthed ? (
            <>
              <div className="taptap1">
                <button
                  className={`Menu ${
                    state.ActiveMenu === "Home" ? "MenuActive" : ""
                  }`}
                  onClick={() => updateActivemenu("Home", "/user-Machines")}
                >
                  <img
                    src={HomeImg}
                    alt="Home"
                  />
                  <p>Home</p>
                </button>
                <button
                  className={`Menu ${
                    state.ActiveMenu === "CMA Machines" ? "MenuActive" : ""
                  }`}
                  onClick={() => updateActivemenu("CMA Machines", "/CMAMachines")}
                >
                  <img
                    src={CmaImg}
                    alt="CMA Machines"
                  />
                  <p>CMA Machines</p>
                </button>
                <button
                  className={`Menu ${
                    state.ActiveMenu === "Service Request" ? "MenuActive" : ""
                  }`}
                  onClick={() =>
                    updateActivemenu("Service Request", "/ServiceRequest")
                  }
                >
                  <img
                    src={ServicsImg}
                    alt="Service Request"
                  />
                  <p>Service Request</p>
                </button>
              </div>
              <div className="taptap2">
                <button
                  className={`Conacts ${
                    state.ActiveMenu === "Help Guide" ? "MenuActive" : ""
                  }`}
                  onClick={() => {
                    updateActivemenu("Help Guide");
                    window.open(
                      "https://docs.interconnecta.com/jadgrp-cma-0311frm",
                      "_blank"
                    );
                  }}
                >
                  <img
                    src={HelpImg}
                    alt="Help Guide"
                  />
                  <p>Help Guide</p>
                </button>

                <button
                  className={`Conacts ${
                    state.ActiveMenu === "Profile" ? "MenuActive" : ""
                  }`}
                  onClick={() => updateActivemenu("Profile", "/Profilepersonal")}
                >
                  <img
                    src={ProfileImg}
                    alt="Profile"
                  />
                  <p>Profile</p>
                </button>
                <div className="Conacts">
                  <img
                    src={BellImg}
                    alt="Bell"
                  />
                </div>
                <button
                  className="Conacts logout-btn"
                  onClick={handleLogout}
                  disabled={isLoggingOut}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  <p>{isLoggingOut ? "Logging out..." : "Logout"}</p>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="taptap1">
                <button
                  className={`Menu ${
                    state.ActiveMenu === "Equipment" ? "MenuActive" : ""
                  }`}
                  onClick={() => updateActivemenu("Equipment", "/equipment")}
                >
                  <img src={CmaImg} alt="Equipment" />
                  <p>Equipment</p>
                </button>
                <button
                  className={`Menu ${
                    state.ActiveMenu === "Parts Inventory" ? "MenuActive" : ""
                  }`}
                  onClick={() =>
                    updateActivemenu("Parts Inventory", "/inventorylist")
                  }
                >
                  <img src={ServicsImg} alt="Parts Inventory" />
                  <p>Parts Inventory</p>
                </button>
              </div>
              <div className="taptap2">
                <button
                  className={`Conacts ${
                    state.ActiveMenu === "Help Guide" ? "MenuActive" : ""
                  }`}
                  onClick={() => {
                    updateActivemenu("Help Guide");
                    window.open(
                      "https://docs.interconnecta.com/jadgrp-cma-0311frm",
                      "_blank"
                    );
                  }}
                >
                  <img src={HelpImg} alt="Help Guide" />
                  <p>Help Guide</p>
                </button>
                <button
                  className="Conacts logout-btn"
                  onClick={() => navigate("/Login")}
                >
                  <img src={ProfileImg} alt="Sign In" />
                  <p>Sign In</p>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Secondheader;
